<!--
  批量话费流量充值
  lovi 2020-07-09
 -->
<template>
  <div class="w100">
    <van-nav-bar
      class="gradient"
      :title="$t('common.batchRecharge')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="_linkFun('/record', 'record', { flag: 100 })">
        {{ $t("common.rechargeRecord") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column-placeholder"></div>
        <div class="column">
          <van-cell-group class="choose-title">
            <van-cell
              :title="titleList[flag]"
              is-link
              @click="titleFlag = true"
            />
          </van-cell-group>
          <task-list
            v-if="flag == 4"
            :getTaskList.sync="getTaskList"
            @getTaskInfo="getTaskInfo"
          />
          <div class="batch-content" v-else>
            <div
              class="batch-item"
              v-for="(item, index) in numberInfo"
              :key="index"
            >
              <number-enter
                ref="numberEnter"
                :numberIndex="index"
                :operatorTitle="item.title"
                :operatorType="item.type"
                :tagList.sync="tagList"
                :tagImportMobile.sync="item.list"
                :tagImportFlag.sync="tagImportFlag"
                :tagAddFlag.sync="tagAddFlag"
                :tagAddMobile.sync="tagAddMobile"
                :showTagFlag.sync="showTagFlag"
                :operatorList="operatorList"
                :allMoney="allMoney"
                @getNumberIndex="getNumberIndex"
              />
            </div>
          </div>
        </div>
        <div class="button-wrap" v-if="flag != 4">
          <van-button block type="primary" @click="nextStep">
            {{ $t("common.nextStep") }}
          </van-button>
          <p class="tips">
            {{ $t("common.payFeesTips") }}
          </p>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <number-list
        v-if="nextStepFlag"
        :nextStepFlag.sync="nextStepFlag"
        :flag="taskType ? taskType : flag"
        :numberList.sync="numberList"
        :taskInfo="taskInfo"
        :operatorState="operatorState"
        :getTaskList.sync="getTaskList"
        :totalMoney.sync="totalMoney"
      />
    </transition>

    <van-popup class="title-pop" v-model="titleFlag" get-container="body">
      <van-cell-group class="title-list" @click="titleFlag = false">
        <van-cell
          :title="$t('recharge.selectRechargeContent')"
          class="text-gray"
          is-link
          arrow-direction="up"
        />
        <van-cell
          :title="item"
          :class="{ active: index == flag }"
          v-for="(item, index) in titleList"
          :key="index"
          @click="chooseTitle(index)"
        />
      </van-cell-group>
    </van-popup>

    <transition name="slide">
      <tag-import
        v-if="tagImportFlag"
        :tagImportFlag.sync="tagImportFlag"
        :tagList.sync="tagList"
        :tagImportMobile.sync="tagImportMobile"
        :numberIndex.sync="numberIndex"
        @getTagImportMobile="getTagImportMobile"
      />
    </transition>

    <transition name="slide">
      <tag-add
        v-if="tagAddFlag"
        :tagAddFlag.sync="tagAddFlag"
        :tagAddMobile="tagAddMobile"
        :tagList.sync="tagList"
        @getUserMobileTags="getUserMobileTags"
      />
    </transition>

    <transition name="slide">
      <tag-show
        v-if="showTagFlag"
        :showTagFlag.sync="showTagFlag"
        :tagList.sync="tagList"
      />
    </transition>
  </div>
</template>

<script>
import NumberEnter from "@/components/recharge/numberEnter";
import NumberList from "@/components/recharge/numberList";
import TagAdd from "@/components/recharge/tagAdd";
import TagShow from "@/components/recharge/tagShow";
import TagImport from "@/components/recharge/tagImport";
import TaskList from "@/components/recharge/taskList";
export default {
  name: "batch",
  props: {},
  components: {
    NumberEnter,
    NumberList,
    TagAdd,
    TagShow,
    TagImport,
    TaskList
  },
  data() {
    return {
      flag: 0, //标题选中下标 0批量话费、1批量流量、2定时批量话费、3定时批量流量、4定时充值任务
      titleFlag: false, //切换标题
      titleList: [
        //标题数组
        this.$t("recharge.batchPhoneFee"),
        this.$t("recharge.batchDataTraffic"),
        this.$t("recharge.timingBatchPhoneFee"),
        this.$t("recharge.timingBatchDataTraffic"),
        this.$t("recharge.timingRechargeTask")
      ],

      operatorList: [], //运营商列表

      taskType: null, //任务列表编辑时的类别 2定时批量话费，3定时批量流量
      taskInfo: {}, //定时任务信息  开关和日期
      getTaskList: false, //修改任务的表示，为true的时候，将列表的数据更新
      tagImportFlag: false, //导入标签标识
      tagImportMobile: [], //从标签中传过来的号码
      tagAddFlag: false, //添加标签标识
      tagAddMobile: [], //添加号码到标签的号码数组,从number组件中传
      showTagFlag: false, //常用号码标识
      nextStepFlag: false, //下一步开关
      numberInfo: [
        //输入框信息，是否有标题
        {
          title: [],
          type: 0,
          list: [[], []]
        }
      ],
      numberList: [], //下一步展示的号码列表
      phoneBatch: [], //号码验证运营商数组
      phoneBatchInfo: {}, //页面信息,仅流量
      tagList: [], //电话簿标签列表

      operatorState: {}, //运营商支持流量套餐状态
      allMoney: {}, //全部金额面板
      totalMoney: 0 //总金额
    };
  },
  created() {
    //初始化
    let vm = this;
    vm.flag = Number(vm.$route.query.flag) || 0;
    vm.initialize();
  },
  mounted() {},
  computed: {},
  methods: {
    initialize() {
      //初始化信息
      let vm = this;
      vm.numberInfo = [];
      vm.getFetchOperatorPre();
      vm.getCallsDenomination();
      vm.operatorDataPackageState();
      if (vm.flag != 4) {
        vm.getUserMobileTags();
      }
      if (vm.flag == 1 || vm.flag == 3) {
        for (let i = 0; i < 2; i++) {
          let obj = {};
          obj.title = [];
          obj.type = i + 1;
          obj.list = [];
          if (i == 0) {
            obj.title = ["Globe", "Smart", "Sun", "Tm","dito"];
          } else {
            obj.title = ["Tnt"];
          }
          vm.numberInfo.push(obj);
        }
      } else {
        let obj = {};
        obj.title = [];
        obj.type = 0;
        obj.list = [];
        vm.numberInfo.push(obj);
      }
      console.log("numberInfo", vm.numberInfo);
    },
    chooseTitle(index) {
      //选择标题
      let vm = this;
      vm.flag = index;
      vm.$router.replace({
        // 跳转到详情
        path: "/batch",
        name: "batch",
        query: { flag: index }
      });
      vm.numberInfo = [];
      //清除任务修改的所有信息
      vm.taskInfo = {};
      vm.taskType = null;
      vm.getTaskList = false;
      vm.initialize();
    },
    getNumberIndex(data) {
      // 获取Number索引
      let vm = this;
      vm.numberIndex = data;
    },
    getTagImportMobile(index, arr) {
      // 获取TagImport号码
      let vm = this;
      vm.numberInfo[index].list = arr;
      console.log("vm.numberInfo", vm.numberInfo);
    },
    changeTask(data) {
      //重新修改了任务
      console.log("changeTask", data);
      this.getTaskList = data;
    },
    getTaskInfo(data) {
      //获取任务数据
      let vm = this;
      vm.taskType = data.type == 20 ? 2 : 3;
      vm.numberList = JSON.parse(data.params);
      if (data.type == 20) {
        for (let i = 0; i < vm.numberList.length; i++) {
          let index = vm.numberList[i].operator_id;
          let obj = {};
          obj = vm.numberList[i];
          obj.denomination = vm.allMoney[index].denomination;
          obj.operator_recharge = vm.allMoney[index].operator_recharge;
          obj.recently = vm.allMoney[index].previous_record;
          vm.$set(vm.numberList, i, obj);
        }
      }
      console.log("numberList", vm.numberList);
      vm.taskInfo = data;
      console.log("taskInfo", data);
      vm.nextStepFlag = true;
    },
    nextStep() {
      //点击下一步
      let vm = this;
      let inputDate = [];
      for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
        //vm.$refs.number[i].getClassify()调用number组件的getClassify()方法，获取输入的号码数据
        inputDate.push(vm.$refs.numberEnter[i].getClassify());
      }
      //判断当前是否有号码
      let hasNum = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].arr.length) {
          hasNum = true;
          break;
        }
      }
      if (!hasNum) {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      //判断是否有错误号码
      let hasError = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].error) {
          hasError = true;
          break;
        }
      }
      if (hasError) {
        vm.$dialog
          .confirm({
            message: vm.$t("recharge.wrongNumberTips"),
            confirmButtonText: vm.$t("common.confirm")
          })
          .then(() => {
            // 确认
            for (let i = 0; i < inputDate.length; i++) {
              if (inputDate[i].error) {
                //去错去重
                vm.$refs.numberEnter[i].deleteSubmit(0);
              }
            }
          })
          .catch(() => {
            // 取消
          });
        return;
      }
      //判断是否有重复号码
      let hasRepeat = false;
      for (let i = 0; i < inputDate.length; i++) {
        if (inputDate[i].repeat) {
          hasRepeat = true;
          break;
        }
      }
      if (hasRepeat) {
        vm.$dialog
          .confirm({
            message: vm.$t("recharge.duplicateNumberTips"),
            confirmButtonText: vm.$t("common.confirm")
          })
          .then(() => {
            // 确认
            inputDate = [];
            for (let i = 0; i < vm.$refs.numberEnter.length; i++) {
              inputDate.push(vm.$refs.numberEnter[i].getClassify(true));
            }
            vm.numberProcessing(inputDate);
          })
          .catch(() => {
            // 取消
          });
        return;
      }
      vm.numberProcessing(inputDate);
    },
    numberProcessing(inputDate) {
      // 号码列表处理
      let vm = this;
      vm.numberList = [];
      for (let i = 0; i < inputDate.length; i++) {
        if (!inputDate[i].arr.length) {
          continue;
        }
        for (let j = 0; j < inputDate[i].arr.length; j++) {
          vm.numberList.push(inputDate[i].arr[j]);
        }
      }
      console.log("numberList", vm.numberList);
      vm.nextStepFlag = true;
    },
    getUserMobileTags() {
      // 电话簿标签列表
      let vm = this;
      vm.$post("/app/user/userMobileTags", {}, { loading: true }).then(res => {
        console.log("userMobileTags", res);
        vm.tagList = res.list;
      });
    },
    operatorDataPackageState() {
      // 运营商支持流量套餐状态
      let vm = this;
      vm.$post(
        "/app/recharge/operatorDataPackageState",
        {},
        { loading: true }
      ).then(res => {
        console.log("operatorDataPackageState", res);
        vm.operatorState = res;
      });
    },
    getCallsDenomination() {
      // 话费充值面板
      let vm = this;
      vm.$post(
        "/app/recharge/callsDenomination",
        { type: 20 },
        { loading: true }
      ).then(res => {
        console.log("callsDenomination", res);
        vm.allMoney = res.list;
      });
    },
    getFetchOperatorPre() {
      //获取运营商字段
      let vm = this;
      vm.$post(
        "/app/index/fetchOperatorPre",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("fetchOperatorPre", res);
        vm.operatorList = res.list;
      });
    }
  },
  watch: {
    numberList: {
      handler: function(arr) {
        console.log("numberList", arr);
        if (!arr.length) {
          return false;
        }
        let money = 0;
        for (let i = 0; i < arr.length; i++) {
          money += arr[i].phones.length * arr[i].amount;
        }
        this.totalMoney = money;
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.text-gray {
  /deep/.van-cell__title {
    color: #999;
  }
}
.scroll-wrapper {
  background: #f4f4f4;
  .column-placeholder {
    height: 15px;
    width: 100%;
  }
  .column {
    margin-top: 0;
  }
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }

  /deep/.scroll-content {
    min-height: 100%;
  }
  .button-wrap {
    p {
      text-align: center;
      color: #9b9b9b;
      font-size: 11px;
      padding: 14px 0;
      span {
        display: block;
      }
    }
  }
  .choose-title {
    margin: 16px 12px;
    border: 1.1px solid #b6b6b6;
    border-radius: 5px;
    overflow: hidden;
    .van-cell__title {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .batch-content {
    border-top: 1.1px solid #e4e4e4;
    .batch-item + .batch-item {
      border-top: 1.1px solid #b6b6b6;
    }
  }
}
.title-pop {
  top: 75px;
  left: 27px;
  right: 27px;
  border-radius: 5px;
  transform: initial;
  .van-cell {
    &:not(:last-child)::after {
      left: 0;
    }
    .van-cell__title {
      font-size: 16px;
    }
    &.active {
      .van-cell__title {
        color: #2042ab;
      }
    }
  }
}
</style>
